import React from 'react';
import PropTypes from 'prop-types';

export default function PlusIcon({ width, height, color }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M16.375 7.9375C16.375 8.96387 15.493 9.79688 14.4062 9.79688H10.4688V13.5156C10.4688 14.542 9.58675 15.375 8.5 15.375C7.41325 15.375 6.53125 14.542 6.53125 13.5156V9.79688H2.59375C1.507 9.79688 0.625 8.96387 0.625 7.9375C0.625 6.91113 1.507 6.07812 2.59375 6.07812H6.53125V2.35938C6.53125 1.333 7.41325 0.5 8.5 0.5C9.58675 0.5 10.4688 1.333 10.4688 2.35938V6.07812H14.4062C15.493 6.07812 16.375 6.91113 16.375 7.9375Z" fill={color} />
    </svg>

  );
}

PlusIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

PlusIcon.defaultProps = {
  color: '#FFFFFF',
  width: 17,
  height: 16,
};
